var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('generic-list',_vm._b({scopedSlots:_vm._u([{key:"item.is_verified",fn:function(ref){
var item = ref.item;
return [_c('v-simple-checkbox',{attrs:{"disabled":""},model:{value:(item.is_verified),callback:function ($$v) {_vm.$set(item, "is_verified", $$v)},expression:"item.is_verified"}})]}}])},'generic-list',{ model: _vm.model, modelHeaders: _vm.modelHeaders, filters: _vm.filters },false))}
var staticRenderFns = []

export { render, staticRenderFns }